// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3LeY9","buttons":"RemoveExpirationActionButtons_buttons__9xhQ0"};